import { TestSuiteDto } from "src/app/models/dto/testSuiteDto";
import { TestSuiteAlternativeDto } from "src/app/models/dto/testSuiteAlternativeDto";
import { TestItemHierarchyLinkDto } from "src/app/models/dto/test-item-hierarchy-link-dto";
import { VehicleFunctionBase } from "src/app/models/dto/vehicleFunctionDto";
import { TestItemHierarchyLinkInput, TestSuiteAlternativeInput, TestSuiteInput } from "../models/input/graphql-test-suite-input";
import { VehicleFunctionBaseInput } from "../models/input/graphql-test-case-input";


import { oldApiSearchIdentity } from "./common.mappers";
  export function convertTestSuiteDtoToGraphqlInput(input: TestSuiteDto): TestSuiteInput {
    return {
      Uid: input.uid ?? '',
      ...oldApiSearchIdentity(input),
      Version: input.version,
      ModifiedBy: input.modifiedBy,
      ModificationTime: null, //input.ModificationTime ? input.ModificationTime.toISOString() : null,
      Comment: input.comment,
      LockedBy: input.lockedBy,
      LockedTime: null, //input.lockedTime ? input.lockedTime.toISOString() : null,
      CreatedBy: input.createdBy,
      CreationTime: null, // input.creationTime ? new Date(new Date(input.creationTime + 'Z').toLocaleString()).toDateString() : null,
      ApprovalStatus: input.approvalStatus,
      ApprovedForTestLevel: input.approvedForTestLevel,
      Label: input.label,
      PromptForMileage: input.promptForMileage,
      SingleUser: input.singleUser,
      ShowNextTestCaseAutomatically: input.showNextTestCaseAutomatically,
      TestCases: input.testCases?.filter(item => !!item.testItemUid).map(item => {
        return convertTestItemHierarchyLinkDtoToGraphqlInput(item)
      }),
      TestSuites: input.testSuites?.filter(item => !!item.testItemUid).map(item => {
        return convertTestItemHierarchyLinkDtoToGraphqlInput(item)
      }),
      OwnerIds: input.ownerIds,
      UserFunctionIds: input.userFunctionIds,
      VehicleFunctions: input.vehicleFunctions?.map(vf => convertVehicleFunctionBaseToGraphqlInput(vf)),
      OffboardComponentIds: input.offboardComponentIds,
      ProductPropertyIds: input.productPropertyIds,
      Description: input.description,
      Alternative: input.alternative ? convertTestSuiteAlternativeDtoToGraphqlInput(input.alternative) : undefined,
      Tags: input.tags,
    }
  }

  export function convertTestSuiteAlternativeDtoToGraphqlInput(input: TestSuiteAlternativeDto ): TestSuiteAlternativeInput  {
    return{
      Uid: input.uid,
      Fpc: input.fpc,
      Tpc: input.tpc,
    }
  }

    export function convertTestItemHierarchyLinkDtoToGraphqlInput(input: TestItemHierarchyLinkDto ): TestItemHierarchyLinkInput  {
      return {
        TestItemUid: input.testItemUid,
        Version: input.version,
        ChildrenTestItemLinks: input.childrenTestItemLinks?.map(item => {
          return convertTestItemHierarchyLinkDtoToGraphqlInput(item)
        }),
        Operator: input.operator,
        Value: input.value
      }
  }

  export function convertVehicleFunctionBaseToGraphqlInput(input: VehicleFunctionBase): VehicleFunctionBaseInput {
    return {
      Id: input.id,
      Name: input.name,
      Revision: input.revision
    }
  }
